import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    chartTooltip: {
      color: token.colorTextLightSolid,
      backgroundColor: token.colorBgSpotlight,
      borderRadius: `${token.borderRadius}px`,
      padding: '12px'
    },

    tooltipText: {
      color: token.colorTextLightSolid
    }
  }
})
